import {
  LegacyCard,
  SkeletonBodyText,
  SkeletonThumbnail,
} from "@shopify/polaris"
import { Fragment } from "react"

const ReviewSkeleton = () => {
  return (
    <LegacyCard>
      <div className="flex items-stretch p-2">
        {[0, 1, 2].map((index) => (
          <Fragment key={index}>
            {index > 0 && (
              <div className="h-11 w-px self-center bg-[#e3e3e3]" />
            )}
            <div className="flex flex-1 items-center gap-4 p-4">
              <SkeletonThumbnail size="extraSmall" />
              <div className="min-w-0 flex-1">
                <SkeletonBodyText lines={2} />
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </LegacyCard>
  )
}

export default ReviewSkeleton
